// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-campaign-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 800px;
  margin: 0 auto;
  margin-bottom: 30px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

/* ==========Message Note Style========= */
.quick-input-field .input-alert-combine {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.quick-input-field small {
  color: #373435;
  font-size: 12px;
  text-align: start;
}

.quick-input-field input {
  width: auto;
}

.quick-input-field label {
  text-align: left; 
  /* font-weight: bold; */
}

.quick-input-field input[type="text"],
.quick-input-field select,
.quick-input-field textarea {
  flex: 1 1; /* Take up remaining space */
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.quick-input-field textarea {
  resize: vertical; /* Allow vertical resizing */
}

.quick-input-field input {
  margin: 0;
}

.hourAndMinute {
    border: 1px solid #373435
}

/* Dynamic Buttons */
.group-form-buttons .btn-submit {
  color: #fff;
  background-color: #44a67e;
  border: 1px solid #44a67e;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: -10px;
}


/* ==========Message Note Style========= */
.quick-input-field .input-alert-combine {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .quick-input-field small {
    color: #373435;
    font-size: 12px;
    text-align: start;
  }

  /* Code for search select dropdown menu  options */
.custom-react-select {
  flex: 1 1;
  width: 100%;
}

.custom-react-select .custom-select__control {
  width: 100%;
  padding: 2px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  min-height: 38px;
  box-shadow: none;
  text-align: left;
}

/* Set the placeholder text to black and left aligned */
.custom-react-select .custom-select__placeholder {
  color: black;
  text-align: left;
  margin-left: 0;
}

.custom-react-select.search-mode .custom-select__placeholder {
  color: #aaa !important; /* light grey */
}

/* Set the selected value text to black */
.custom-react-select .custom-select__single-value {
  color: black;
  text-align: left;
}

/* Make dropdown menu options black */
.custom-react-select .custom-select__option {
  font-size: 14px;
  padding: 8px 12px;
  color: black;
  text-align: left;
}

/* Style focused option */
.custom-react-select .custom-select__option--is-focused {
  background-color: #f0f0f0;
  color: black;
}

/* Style selected option */
.custom-react-select .custom-select__option--is-selected {
  background-color: #007bff;
  color: white;
}

/* Remove yellow box shadow on focus */
.custom-react-select .custom-select__control--is-focused {
  box-shadow: none !important;
  border-color: #ccc !important; /* Optional: set to your default border */
}

/* Also handle hover state if needed */
.custom-react-select .custom-select__control:hover {
  border-color: #ccc;
}

/* Optional: remove default browser highlight on input */
.custom-react-select input:focus {
  outline: none;
  box-shadow: none !important;
}
/* Code for search select dropdown menu  options */

  .groupWrapHourTime {
    display: flex;
    width: 35%;
    gap: 10%;
  }
  
  .groupWrapHourTime .hourAndMinute{
    padding: 0.75rem;
  }`, "",{"version":3,"sources":["webpack://./src/components/GroupCampaign/GroupCampaign.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,SAAO,EAAE,4BAA4B;EACrC,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA;EACE,SAAS;AACX;;AAEA;IACI;AACJ;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;;AAGA,0CAA0C;AAC1C;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA,kDAAkD;AACpD;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB,EAAE,eAAe;AACzC;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,2BAA2B;EAC3B,6BAA6B,EAAE,yCAAyC;AAC1E;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA,kDAAkD;;EAEhD;IACE,aAAa;IACb,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB","sourcesContent":[".group-campaign-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n  margin-bottom: 30px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  padding: 20px;\r\n  background-color: #fff;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* ==========Message Note Style========= */\r\n.quick-input-field .input-alert-combine {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.quick-input-field small {\r\n  color: #373435;\r\n  font-size: 12px;\r\n  text-align: start;\r\n}\r\n\r\n.quick-input-field input {\r\n  width: auto;\r\n}\r\n\r\n.quick-input-field label {\r\n  text-align: left; \r\n  /* font-weight: bold; */\r\n}\r\n\r\n.quick-input-field input[type=\"text\"],\r\n.quick-input-field select,\r\n.quick-input-field textarea {\r\n  flex: 1; /* Take up remaining space */\r\n  padding: 8px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.quick-input-field textarea {\r\n  resize: vertical; /* Allow vertical resizing */\r\n}\r\n\r\n.quick-input-field input {\r\n  margin: 0;\r\n}\r\n\r\n.hourAndMinute {\r\n    border: 1px solid #373435\r\n}\r\n\r\n/* Dynamic Buttons */\r\n.group-form-buttons .btn-submit {\r\n  color: #fff;\r\n  background-color: #44a67e;\r\n  border: 1px solid #44a67e;\r\n  padding: 10px 20px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  margin-top: -10px;\r\n}\r\n\r\n\r\n/* ==========Message Note Style========= */\r\n.quick-input-field .input-alert-combine {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n  \r\n  .quick-input-field small {\r\n    color: #373435;\r\n    font-size: 12px;\r\n    text-align: start;\r\n  }\r\n\r\n  /* Code for search select dropdown menu  options */\r\n.custom-react-select {\r\n  flex: 1;\r\n  width: 100%;\r\n}\r\n\r\n.custom-react-select .custom-select__control {\r\n  width: 100%;\r\n  padding: 2px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  min-height: 38px;\r\n  box-shadow: none;\r\n  text-align: left;\r\n}\r\n\r\n/* Set the placeholder text to black and left aligned */\r\n.custom-react-select .custom-select__placeholder {\r\n  color: black;\r\n  text-align: left;\r\n  margin-left: 0;\r\n}\r\n\r\n.custom-react-select.search-mode .custom-select__placeholder {\r\n  color: #aaa !important; /* light grey */\r\n}\r\n\r\n/* Set the selected value text to black */\r\n.custom-react-select .custom-select__single-value {\r\n  color: black;\r\n  text-align: left;\r\n}\r\n\r\n/* Make dropdown menu options black */\r\n.custom-react-select .custom-select__option {\r\n  font-size: 14px;\r\n  padding: 8px 12px;\r\n  color: black;\r\n  text-align: left;\r\n}\r\n\r\n/* Style focused option */\r\n.custom-react-select .custom-select__option--is-focused {\r\n  background-color: #f0f0f0;\r\n  color: black;\r\n}\r\n\r\n/* Style selected option */\r\n.custom-react-select .custom-select__option--is-selected {\r\n  background-color: #007bff;\r\n  color: white;\r\n}\r\n\r\n/* Remove yellow box shadow on focus */\r\n.custom-react-select .custom-select__control--is-focused {\r\n  box-shadow: none !important;\r\n  border-color: #ccc !important; /* Optional: set to your default border */\r\n}\r\n\r\n/* Also handle hover state if needed */\r\n.custom-react-select .custom-select__control:hover {\r\n  border-color: #ccc;\r\n}\r\n\r\n/* Optional: remove default browser highlight on input */\r\n.custom-react-select input:focus {\r\n  outline: none;\r\n  box-shadow: none !important;\r\n}\r\n/* Code for search select dropdown menu  options */\r\n\r\n  .groupWrapHourTime {\r\n    display: flex;\r\n    width: 35%;\r\n    gap: 10%;\r\n  }\r\n  \r\n  .groupWrapHourTime .hourAndMinute{\r\n    padding: 0.75rem;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
